<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="ageRange.id === null">{{ 'NEWAGERANGE' | translate }}</span>
            <span *ngIf="ageRange.id !== null">{{ 'EDITAGERANGE' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="ageRangeForm" id="ageRangeForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="ageRangeForm" >
            <input type="hidden" name="id" id="ageRangeId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="ageRangeName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="ageRangeName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="ageRangeForm.controls['name'].invalid && (ageRangeForm.controls['name'].dirty || ageRangeForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="ageRangeForm.controls['name'].errors !== null">
                  <div *ngIf="ageRangeForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="ageRangeNameAr" formControlName="nameAr" type="text" pInputText [required]="false"> 
                      <label for="ageRangeNameAr" class="">{{ 'NAMEAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="ageRangeNameFr" formControlName="nameFr" type="text" pInputText [required]="false"> 
                      <label for="ageRangeNameFr" class="">{{ 'NAMEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-birthday-cake"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="ageRangeMinAge" formControlName="minAge" [step]="1" [showButtons]="true" [required]="true"></p-inputNumber>
                      <label for="ageRangeMinAge" class="req">{{ 'MINAGE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="ageRangeForm.controls['minAge'].invalid && (ageRangeForm.controls['minAge'].dirty || ageRangeForm.controls['minAge'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="ageRangeForm.controls['minAge'].errors !== null">
                  <div *ngIf="ageRangeForm.controls['minAge'].errors.required">
                   {{ 'MINAGEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-birthday-cake"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="ageRangeMaxAge" formControlName="maxAge" [step]="1" [showButtons]="true" [required]="true"></p-inputNumber>
                      <label for="ageRangeMaxAge" class="req">{{ 'MAXAGE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="ageRangeForm.controls['maxAge'].invalid && (ageRangeForm.controls['maxAge'].dirty || ageRangeForm.controls['maxAge'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="ageRangeForm.controls['maxAge'].errors !== null">
                  <div *ngIf="ageRangeForm.controls['maxAge'].errors.required">
                   {{ 'MAXAGEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-icons "></i>
                    </span>
                    <span class="p-float-label">
                      <input id="ageRangeIcon" formControlName="icon" type="text" pInputText [required]="false"> 
                      <label for="ageRangeIcon" class="">{{ 'ICON' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info" (click)="openFilerDialog('icon')"></button> 
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="ageRangeIsPublished" formControlName="isPublished" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="ageRangeIsPublished" class="p-d-inline-block p-ml-2 req">{{ 'ISPUBLISHED' | translate }}</label>
                </div>
                <div *ngIf="ageRangeForm.controls['isPublished'].invalid && (ageRangeForm.controls['isPublished'].dirty || ageRangeForm.controls['isPublished'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="ageRangeForm.controls['isPublished'].errors !== null">
                  <div *ngIf="ageRangeForm.controls['isPublished'].errors.required">
                   {{ 'ISPUBLISHEDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKAGERANGES' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="ageRange.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!ageRangeForm.valid || disableSubmit"> <!--  [disabled]="ageRangeForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!ageRangeForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

